<template>
  <div class="scroll-container" :class="{leftmost: leftMost, rightmost: rightMost}" ref="container">
    <div class="scroller" ref="scroller" @scroll="scrollerScrolled">
      <div class="items" ref="items">
        <a :href="item[3]" target="_blank" class="item" v-for="item in items" :key="item" @click="$emit('track', item[0])">
          <div class="inner">
            <div class="image">
              <img :src="getImageUrl(item[2])">
            </div>
            <div class="info">
              <h3 class="title">{{ item[0] }}</h3>
              <p class="lead">
                {{ item[1] }}
              </p>
              <div class="cta external">Kjøp</div>
            </div>
            <div class="discount" v-if="item[4]">
              {{ item[4] }}
            </div>
          </div>
        </a>
      </div>
    </div>
    <button class="nav prev" @click="scrollToPrev"></button>
    <button class="nav next" @click="scrollToNext"></button>
  </div>
</template>

<script>
  export default {
    name: 'ExpanderScroller',
    emits: ['track'],
    props: {
      items: Array,
      reverse: Boolean
    },
    data() {
      return {
        leftMost: true,
        rightMost: false,
        autoscroll: false,
        autoscrollSpeed: 2500
      }
    },
    methods: {
      getImageUrl(image) {
        return require(`@/assets/products/${image}`)
      },
      scrollToPrev: function() {
        let w = this.$refs.items.children[0].offsetWidth
        this.$refs.scroller.scrollBy({left: w * -1, behavior: 'smooth'})
      },
      scrollToNext: function() {
        let w = this.$refs.items.children[0].offsetWidth
        this.$refs.scroller.scrollBy({left: w, behavior: 'smooth'})
      },
      scrollerScrolled: function() {
        this.leftMost = (this.$refs.scroller.scrollLeft < 50)
        this.rightMost = (this.$refs.scroller.scrollLeft > this.$refs.items.offsetWidth - this.$refs.container.offsetWidth - 50)
      }
    },
    mounted() {
      let rootEl = document.querySelector('.section-scroller .container')
      let handleIntersect = (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting)
            entry.target.classList.add('active')
          else
            entry.target.classList.remove('active')
        });
      };
      let observer = new IntersectionObserver(handleIntersect, {root: rootEl, rootMargin: '100% -45% 100% -45%'})
      let targets = document.querySelectorAll('.section-scroller .item')
      targets.forEach(target => {
        observer.observe(target)
      });

      if (this.autoscroll) {
        setInterval(() => {
          if (this.rightMost)
            this.$refs.scroller.scrollTo({left: 0, behavior: 'smooth'})
          else
            this.scrollToNext()
        }, this.autoscrollSpeed || 2500)
      }
      if (this.reverse && window.innerWidth > 480) {
        this.$refs.scroller.scrollTo(this.$refs.items.offsetWidth, 0)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  .scroll-container {
    position: relative;
  }
  .scroller {
    overflow: auto;
    scroll-snap-type: x mandatory;
    padding-bottom: 1rem;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .scroller::-webkit-scrollbar {
    display: none;
  }
  .items {
    display: inline-flex;
    justify-content: space-between;
    align-items: stretch;
    padding: 0 1rem;
  }
  .item {
    display: block;
    width: 18rem;
    scroll-snap-align: center;
    padding: .625rem;
    @include d {
      width: 21.25rem;
    }
    .inner {
      position: relative;
      min-height: 100%;
      border-radius: 15.625rem 15.625rem 2.5rem 2.5rem;
      background: #fff;
      overflow: hidden;
      box-shadow: 0rem .125rem .625rem 0rem rgba(0, 0, 0, 0.05), 0rem .0625rem .125rem 0rem rgba(0, 0, 0, 0.15);
    }
    .image {
      img {
        max-width: none;
        width: 100%;
        aspect-ratio: 268/300;
        object-fit: cover;
        object-position: center center;
        @include d {
          aspect-ratio: 320/360;
        }
      }
    }
    .info {
      padding: 1.5rem 2rem 3rem;
    }
    .title {
      margin-bottom: .75rem;
      font-size: 1rem;
      font-weight: 900;
    }
    .lead {
      margin-bottom: 1.875rem;
      font-size: .6875rem;
      letter-spacing: -0.00688rem;
      @include d {
        font-size: .75rem;
      }
    }
    .discount {
      position: absolute;
      right: 0;
      top: 14.25rem;
      padding: 0.5rem 1.125rem;
      font-size: .875rem;
      font-weight: 600;
      color: #fff;
      background: #648BCA;
      border-radius: 0.5rem 0rem 0rem 0.5rem;
      @include d {
        top: 18rem;
      }
    }
    .cta {
      position: absolute;
      left: 2rem;
      bottom: 1.5rem;
      font-weight: 900;
    }
  }
  .item + .item {
    margin-left: 1rem;
    @include d {
      margin-left: 2.5rem;
    }
  }

  .nav {
    position: absolute;
    top: 50%;
    z-index: 10;
    width: 2.5rem;
    height: 2.5rem;
    border: 0;
    overflow: hidden;
    border-radius: 50%;
    box-shadow: 0rem .125rem .625rem 0rem rgba(0, 0, 0, 0.05);
    transform: translate(0, -50%);
    cursor: pointer;
    &.prev {
      left: 1rem;
      background: #fff url('../assets/icons/arrow-left.svg') no-repeat center center / 1.5rem auto;
    }
    &.next {
      right: 1rem;
      background: #fff url('../assets/icons/arrow-right.svg') no-repeat center center / 1.5rem auto;
    }
  }

  .leftmost .prev {
    display: none;
  }
  .rightmost .next {
    display: none;
  }

</style>

